import { OrdersCustomerDataCell } from "./OrdersCustomerDataCell";
import { ColDef } from "ag-grid-community";
import { OrderIdHeader } from "./OrderIdHeader";
import { OrdersPreSelectedQuoteCell } from "./OrdersPreSelectedQuoteCell";
import { OrdersActionsHeader } from "./OrdersActionsHeader";
import { OrdersIdCell } from "./OrdersIdCell";
import { OrdersActionCell } from "./OrdersActionCell";
import { OrderPrivateNotes } from "./OrderPrivateNotes";
import { OrdersPricingCell } from "./OrderPricing";
import { ItemCell } from "../ShipmentsTable/ItemCell";
import { ConsignmentCell } from "../ShipmentsTable/ConsignmentCell";

export const shipmentTableColumnsData = ({
  onRefreshData,
  setSnackBar,
}: {
  onRefreshData?: () => void;
  setSnackBar: (snackbarState: { open: boolean; message: string; severity: string }) => void;
}) =>
  [
    {
      headerName: "Order ID",
      field: "orderID",
      width: 250,
      pinned: "left",
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      cellRenderer: OrdersIdCell,
      sortable: false,
      headerComponent: OrderIdHeader,
    },
    {
      headerName: "Item",
      field: "item",
      width: 800,
      cellRenderer: ItemCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
    },
    {
      headerName: "Pricing Details",
      field: "orderPricing",
      width: 250,
      cellRenderer: OrdersPricingCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
      cellRendererParams: { refreshData: onRefreshData, setSnackBar },
    },
    {
      headerName: "Preselected quotes",
      field: "labelNumber",
      width: 300,
      cellRenderer: OrdersPreSelectedQuoteCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
      cellRendererParams: { refreshData: onRefreshData, setSnackBar },
    },
    {
      headerName: "Consignment",
      field: "labelNumber",
      width: 400,
      cellRenderer: ConsignmentCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
      cellRendererParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
    },
    {
      headerName: "Customer Contact",
      field: "shipToPhone",
      width: 500,
      cellRenderer: OrdersCustomerDataCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
      cellRendererParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
    },
    {
      headerName: "Internal Notes",
      field: "internalNote",
      cellRenderer: OrderPrivateNotes,
      cellRendererParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
      width: 300,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
    },
    { headerName: "Error", width: 250, sortable: false },
    {
      headerName: "Actions",
      width: 250,
      pinned: "right",
      sortable: false,
      cellRenderer: OrdersActionCell,
      cellRendererParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
      headerComponent: OrdersActionsHeader,
      headerComponentParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
    },
  ] as ColDef[];
